module.exports = __webpack_public_path__ + "assets/img/online.0300caa2.png";